import { createFileRoute } from '@tanstack/react-router'
import { requireTrainer } from '@/lib/auth-guards'
import { TrainerHomePage } from '@/features/trainers'

export const Route = createFileRoute('/_authenticated/trainer/')({
  beforeLoad: async () => {
    await requireTrainer()
  },
  component: TrainerHomePage,
})
